import styled from 'styled-components';
import { colorPalette, getSpacing, typography } from 'stylesheet';

export const CollapsableFormZoneTitle = styled.div`
  margin: ${getSpacing(2)};
  margin-bottom: 0;
  padding: ${getSpacing(2)};
  border-bottom: 1px solid;
  border-color: lightgrey;
  ${typography.p1_bold}
  border-top-left-radius: ${getSpacing(2)};
  border-top-right-radius: ${getSpacing(2)};
  background: ${colorPalette.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CollapsableFormZoneContent = styled.div`
  margin: ${getSpacing(2)};
  margin-top: 0;
  padding: ${getSpacing(2)};
  ${typography.p1_regular}
  border-bottom-left-radius: ${getSpacing(2)};
  border-bottom-right-radius: ${getSpacing(2)};
  background: ${colorPalette.white};
`;

export const CollapsableFormZoneContainer = styled.div`
  margin-bottom: ${getSpacing(1)};
`;
